// extracted by mini-css-extract-plugin
export default {"ApplicationContentContainer__Root":"ApplicationContentContainer_ApplicationContentContainer__Root__F6DyV"};